(function($) {

  $(function() {

    $('#user_login').attr('placeholder', 'E-mail')
    $('#user_pass').attr('placeholder', 'Contraseña')
  })

})(jQuery)